// QR-Code als SVG (Zwei-Faktor-Schlüssel). Immer schwarz auf weiß mit Rand, auch im dunklen Thema, sonst liest ihn die Kamera nicht.
import { useMemo } from "react";
import { qrPfad } from "./qr";

export function QrBild({ text, titel }: { text: string; titel: string }) {
  const qr = useMemo(() => {
    try {
      return qrPfad(text);
    } catch {
      return null;
    }
  }, [text]);
  if (!qr) return null;
  const rand = 2;
  const ganz = qr.groesse + 2 * rand;
  return (
    <svg viewBox={`${-rand} ${-rand} ${ganz} ${ganz}`} role="img" aria-label={titel} shapeRendering="crispEdges">
      <rect x={-rand} y={-rand} width={ganz} height={ganz} fill="#ffffff" />
      <path d={qr.d} fill="#000000" />
    </svg>
  );
}
